import './stylesheets/App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { useState, useEffect } from "react";
import { revealListen } from './modules/modules.js';
import './stylesheets/hi.css';
import About from './views/About';
import Work from './views/Work';
import Contact from './views/Contact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faDownload, faEnvelope } from '@fortawesome/free-solid-svg-icons';

function App() {

  useEffect(() => {
    revealListen();
  }, []);

  const hideMenu = () => {
    const menueElement = document.getElementById("menu");
    menueElement.classList.remove("show");
  };

  return (
    <div className="App">
      <header className="App-header">

        <div className="container-fluid">

          <div className="row main">

            {/* Sidebar Navigation */}
            <nav className="col-xl-1 p-0 menu" id="menu">

              <a href="#hi" className="logo-link">
                <div className="logo">
                  <span className="logo-m">M</span>
                  <span className="logo-a">A</span>
                </div>
              </a>
              <a href="#about"><span className="m-i" onClick={hideMenu}>About</span></a>
              <a href="#work"><span className="m-i" onClick={hideMenu}>Work</span></a>
              <a href="#contact"><span className="m-i" onClick={hideMenu}>Contact</span></a>

            </nav>

            {/* Main Content */}
            <div className="col-xl-11 p-0 page1">

              {/* Mobile toggler */}
              <nav className="navbar navbar-expand-xl bg-dark navbar-dark" id="menu-b">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#menu">
                  <span className="navbar-toggler-icon"></span>
                </button>
              </nav>

              {/* Hero Section */}
              <section className="d-flex justify-content-center flex-column" id="hi">

                <p className="hero-pre">Hi there, I'm</p>

                <h1 className="hero-name">
                  <span className="highlight">Mostafa Abo Elkheir</span>
                </h1>

                <h2 className="hero-title">Software Engineer</h2>

                <p className="hero-desc">
                  Software engineer passionate about building elegant, scalable web
                  applications — from intuitive front-end experiences to robust back-end APIs.
                </p>

                <div className="hero-buttons">
                  <a href="#contact" className="text-d-n">
                    <button className="contact-button">
                      <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
                      Contact Me
                    </button>
                  </a>
                  <a
                    href="/Mostafa Ahmed.pdf"
                    download="Mostafa Ahmed CV.pdf"
                    className="cv-button"
                  >
                    <FontAwesomeIcon icon={faDownload} />
                    Download CV
                  </a>
                </div>

                <div className="scroll-indicator">
                  <div className="scroll-line"></div>
                  <span className="scroll-text">scroll down</span>
                </div>

              </section>

              <About />

              <Work />

              <Contact />

              <footer className="my-github">
                <a href="https://github.com/mostafa-abuelkhair" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon className="github-icon" icon={faGithub} />
                </a>
                <p>Designed &amp; Built by Mostafa Abo Elkheir &copy; 2025</p>
              </footer>

            </div>

          </div>
        </div>

      </header>
    </div>
  );
}

export default App;
